import { PasteResponseDTO, TreeNode } from 'business/models/Models';
import React from 'react';

interface Props {
  response: PasteResponseDTO;
}
const PasteResponseModalBody = (props: Props) => {
  const { response } = props;
  const { pastedNodes, unableToPasteNodes } = response;
  return (
    <>
      {pastedNodes.length > 0 && (
        <div id='explorer-pasteresponsemodalbody-message'>
          The following files have been pasted.
          <br />
          {pastedNodes.map((node: TreeNode, index) => (
            <div id={`explorer-pasteresponsemodalbody-pasted-${index}`} 
              className="ml-4" key={index}>{`${index + 1}) ${node.name}`}</div>
          ))}
        </div>
      )}
      {unableToPasteNodes.length > 0 && (
        <div id="explorer-pasteresponsemodalbody-unablelist">
          These following files have not been pasted, hover to see details.
          {unableToPasteNodes.map((nodeResponse, index) => (
            <div id={`explorer-pasteresponsemodalbody-unable-${index}`}
                className="text-red-800 ml-4" key={index} title={nodeResponse.reason}>
              {`${index + 1}) ${nodeResponse.treeNode.name}`}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default PasteResponseModalBody;
